import axios from 'axios'
import {base} from './api'
import Qs from 'qs'

//列表
export var getCasePreList = params => { return axios.get(`${base}/h5/casePre/list`, {params:{}}).then(res => res.data); };
export var getPushCasePre = params => { return axios.get(`${base}/h5/casePre/drivePush/`+params.caseUid, {params:{}}).then(res => res.data); };

